/* eslint-disable react/no-children-prop */
import React from "react";
import { Wrapper } from "./styled";

const Header = ({ content }) => {
  return <Wrapper children={content} />;
};

export default Header;
